import { useState, useContext, useEffect } from "react";
import { Switch, VStack, HStack, Text, useToast, Badge } from "@chakra-ui/react";
import { ethers } from "ethers";
import { AppContext } from "../../AppContext";
import BlindfoldWalletV2 from "../../contracts/BlindfoldWalletV2.json"; // Import contract ABI

const TradeStatusToggle = () => {
  const { fastestWebSocket, contractAddress } = useContext(AppContext);

  const [tradesEnabled, setTradesEnabled] = useState(false);
  const toast = useToast();

  useEffect(() => {
    const fetchTradeStatus = async () => {
      try {
        const provider = new ethers.providers.WebSocketProvider(fastestWebSocket);
        const contract = new ethers.Contract(contractAddress, BlindfoldWalletV2.abi, provider);
        const status = await contract.tradesEnabled(); // Assuming tradesEnabled is a public state variable
        setTradesEnabled(status);
      } catch (error) {
        console.error("Error fetching trade status:", error);
      }
    };

    fetchTradeStatus();
  }, [fastestWebSocket, contractAddress]);

  const toggleTradeStatus = async () => {
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const contract = new ethers.Contract(contractAddress, BlindfoldWalletV2.abi, signer);

      const tx = await contract.setTradeStatus(!tradesEnabled);
      await tx.wait();
      setTradesEnabled(!tradesEnabled);

      toast({
        title: "Trade Status Updated",
        description: `Trading is now ${!tradesEnabled ? "enabled" : "disabled"}.`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Error updating trade status:", error);
      toast({
        title: "Transaction Failed",
        description: error.message || "Could not update trade status.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <VStack spacing={1} align="start" fontFamily={'Sentinel'}>
      {/* Description */}
      <Text fontWeight="bold" fontSize="lg">Trading Status</Text>
      <Text fontSize="sm" color="gray.600">
        This switch controls whether trades are allowed. Disabling trading will prevent any new positions from being opened.
      </Text>

      {/* Toggle Switch with Label */}
      <HStack spacing={3} w="full" justify="space-between">
        <Text fontWeight="medium">Enable/Disable Trading:</Text>
        <Switch isChecked={tradesEnabled} onChange={toggleTradeStatus} colorScheme="blue" />
      </HStack>

      {/* Status Badge */}
      <Badge colorScheme={tradesEnabled ? "green" : "red"} fontSize="sm">
        {tradesEnabled ? "Trading Enabled" : "Trading Disabled"}
      </Badge>
    </VStack>
  );
};

export default TradeStatusToggle;
